import { ApiRouteDefinition } from "@auth0/auth0-angular";

export interface Auth0Config {
    auth: {
        domain: string;
        clientId: string;
        authorizationParams: {
            audience?: string;
            redirect_uri?: string,
        };
        apiUri: string;
        appUri: string;
        errorPath: string;
    },
    httpInterceptor: {
        allowedList: [ApiRouteDefinition];
    }
    apiUrl: string;
    gqlUrl: string;
    contactUsMail: string;
}


export const AUTH0_CONFIGS: { [key: string]: Auth0Config } = {
    development: {
        auth: {
            domain: "auth.dev.fortasolutions.com",
            clientId: "sZcgmIxDvjonOFdIjGgb0g1txMaptJYF",
            authorizationParams: {
                audience: "https://forta-dev.us.com/",
                redirect_uri: 'https://dev.fortasolutions.com/secure',
            },
            apiUri: "https://api.dev.fortasolutions.com",
            appUri: "http://localhost:4200",
            errorPath: "/error"
        },
        httpInterceptor: {
            allowedList: ['https://api.dev.fortasolutions.com/*'],
        },
        apiUrl: 'https://api.dev.fortasolutions.com',
        gqlUrl: 'https://api.dev.fortasolutions.com/graphql',
        contactUsMail: 'info@fortasolutions.com',
    },
    qa: {
        auth: {
            domain: "auth.qa.fortasolutions.com",
            clientId: "yaOmr3x5BrQHt2iGsH3GfBG46tSSTF1b",
            authorizationParams: {
                audience: "https://forta-qa.us.com/",
                redirect_uri: 'https://qa.fortasolutions.com/secure',
            },
            apiUri: "https://api.qa.fortasolutions.com",
            appUri: "http://localhost:4200",
            errorPath: "/error"
        },
        httpInterceptor: {
            allowedList: ['https://api.qa.fortasolutions.com/*'],
        },
        apiUrl: 'https://api.qa.fortasolutions.com',
        gqlUrl: 'https://api.qa.fortasolutions.com/graphql',
        contactUsMail: 'info@fortasolutions.com',
    },
    uat: {
        auth: {
            domain: "auth.uat.fortasolutions.com",
            clientId: "ZbAbs8XIuBtaTf03ijvJ9jgL8a1TjO3Z",
            authorizationParams: {
                audience: "https://masterpermissions.uat.fortasolutions.com",
                redirect_uri: 'https://uat.fortasolutions.com/secure',
            },
            apiUri: "https://api.uat.fortasolutions.com",
            appUri: "http://localhost:4200",
            errorPath: "/error"
        },
        httpInterceptor: {
            allowedList: ['https://api.uat.fortasolutions.com/*'],
        },
        apiUrl: 'https://api.uat.fortasolutions.com',
        gqlUrl: 'https://api.uat.fortasolutions.com/graphql',
        contactUsMail: 'info@fortasolutions.com',
    },
    preProd: {
        auth: {
            domain: "auth.preprod.fortasolutions.com",
            clientId: "x82dlxhbS7EU2NKTqfIEOYeYXJBSLfoU",
            authorizationParams: {
                audience: "https://masterpermissions.preprod.fortasolutions.com/",
                redirect_uri: 'https://preprod.fortasolutions.com/secure',
            },
            apiUri: "https://api.preprod.fortasolutions.com",
            appUri: "http://localhost:4200",
            errorPath: "/error"
        },
        httpInterceptor: {
            allowedList: ['https://api.preprod.fortasolutions.com/*'],
        },
        apiUrl: 'https://api.preprod.fortasolutions.com',
        gqlUrl: 'https://api.preprod.fortasolutions.com/graphql',
        contactUsMail: 'info@fortasolutions.com',
    },
    preProdQa: {
        auth: {
            domain: "auth.preprod-qa.fortasolutions.com",
            clientId: "Srq8ZsezLiTbqKgJTWtYag5dm2BBuidB",
            authorizationParams: {
                audience: "https://masterpermissions.preprod-qa.fortasolutions.com/",
                redirect_uri: 'https://preprod-qa.fortasolutions.com/secure',
            },
            apiUri: "https://api.preprod-qa.fortasolutions.com/",
            appUri: "http://localhost:4200",
            errorPath: "/error"
        },
        httpInterceptor: {
            allowedList: ['https://api.preprod-qa.fortasolutions.com/*'],
        },
        apiUrl: 'https://api.preprod-qa.fortasolutions.com',
        gqlUrl: 'https://api.preprod-qa.fortasolutions.com/graphql',
        contactUsMail: 'info@fortasolutions.com',
    },
    production: {
        auth: {
            domain: "forta-prod.us.auth0.com",
            clientId: "x82dlxhbS7EU2NKTqfIEOYeYXJBSLfoU",
            authorizationParams: {
                audience: "https://masterpermissions.prod.fortasolutions.com/",
                redirect_uri: 'https://agility.fortasolutions.com/secure',
            },
            apiUri: "https://api.agility.fortasolutions.com",
            appUri: "http://localhost:4200",
            errorPath: "/error"
        },
        httpInterceptor: {
            allowedList: ['https://api.agility.fortasolutions.com/*'],
        },
        apiUrl: 'https://api.agility.fortasolutions.com',
        gqlUrl: 'https://api.agility.fortasolutions.com/graphql',
        contactUsMail: 'info@fortasolutions.com',
    },
};